// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app {\n  font-family: PingFangSC-Regular, PingFang SC;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #333330;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.panel {\n  width: 100%;\n  position: relative;\n  flex: 1;\n  padding-bottom: 34px;\n  border-top: 1px #ffffff solid;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
